import styled from "@emotion/styled";

export const RichTextOptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
`;

export const RichTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  .ProseMirror {
    border: 1px solid #ccc;
    border-radius: 6px;
    height: calc(100vh - 400px);
    color: #333;
    background: white;
    overflow-y: auto;
  }
  .IconOption {
    cursor: pointer;
  }
`;

